import React from "react";
import { SaveConfigManager } from "../states/SaveConfigManager";

export const SaveConfigContext =
  React.createContext<SaveConfigManager>(undefined);
export const SaveConfigProvider = SaveConfigContext.Provider;
